export default function Beneficiaries({ setCurrentPage }) {
  const features = [
    { icon: 'ti-cash',     title: 'View Payments',     desc: 'See all your cash transfers' },
    { icon: 'ti-history',  title: 'Payment History',   desc: 'Track all past transactions' },
    { icon: 'ti-user',     title: 'Manage Profile',    desc: 'Update your information' },
    { icon: 'ti-download', title: 'Download Reports',  desc: 'Export your transaction history' },
    { icon: 'ti-bell',     title: 'Notifications',     desc: 'Get payment and status alerts' },
    { icon: 'ti-phone',    title: '24/7 Support',      desc: 'Reach us via Toll-Free 1533' },
  ];

  return (
    <div>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, var(--primary-color) 0%, #0052a3 100%)',
        color: 'white', padding: '48px 28px',
        borderRadius: '12px', marginBottom: '32px', textAlign: 'center',
        animation: 'slideInDown 0.5s ease-out',
      }}>
        <h1 style={{ fontSize: '32px', fontWeight: '700', margin: '0 0 10px' }}>
          Beneficiary Portal
        </h1>
        <p style={{ fontSize: '16px', margin: 0, opacity: 0.9 }}>
          Access your account and manage your benefits
        </p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '28px', maxWidth: '1000px', margin: '0 auto',
      }}>

        {/* Login CTA */}
        <div style={{
          background: 'white', borderRadius: '12px',
          padding: '32px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          animation: 'slideInUp 0.5s ease-out',
        }}>
          <div style={{
            width: '56px', height: '56px',
            background: 'linear-gradient(135deg, var(--primary-color), #0052a3)',
            borderRadius: '12px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '26px', marginBottom: '20px',
          }}></div>

          <h2 style={{ fontSize: '20px', fontWeight: '700', margin: '0 0 12px', color: 'var(--text-dark)' }}>
            Already a Beneficiary?
          </h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px', lineHeight: 1.7, marginBottom: '24px' }}>
            If your application has been approved, you would have received your login credentials by email. Sign in to access your dashboard, track payments, and manage your account.
          </p>

          {/* Credentials info */}
          <div style={{
            background: '#e0f2fe', border: '1px solid #0284c7',
            borderRadius: '8px', padding: '12px 14px',
            marginBottom: '24px', display: 'flex', gap: '10px',
          }}>
            <span style={{ fontSize: '16px' }}></span>
            <p style={{ margin: 0, fontSize: '12px', color: '#0c4a6e', lineHeight: 1.65 }}>
              Your <strong>Beneficiary ID</strong> and <strong>password</strong> were sent to your email after your application was approved. Check your inbox or spam folder.
            </p>
          </div>

          <button
            onClick={() => setCurrentPage('login')}
            style={{
              width: '100%',
              background: 'linear-gradient(135deg, var(--primary-color), #0052a3)',
              color: 'white', border: 'none',
              padding: '14px', borderRadius: '8px',
              fontSize: '15px', fontWeight: '600', cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0,102,204,0.3)',
              marginBottom: '14px',
            }}
          >
            Sign In to Portal ?
          </button>

          <div style={{ textAlign: 'center', paddingTop: '14px', borderTop: '1px solid var(--border-light)' }}>
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: '0 0 10px' }}>
              Haven't applied yet?
            </p>
            <button
              onClick={() => setCurrentPage('apply')}
              style={{
                background: 'transparent', color: 'var(--primary-color)',
                border: '1.5px solid var(--primary-color)', borderRadius: '8px',
                padding: '10px 20px', fontSize: '14px',
                fontWeight: '600', cursor: 'pointer',
              }}
            >
              Submit an Application
            </button>
          </div>
        </div>

        {/* Features + credential info */}
        <div>
          <div style={{
            background: 'white', borderRadius: '12px',
            padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            marginBottom: '20px', animation: 'slideInUp 0.6s ease-out',
          }}>
            <h3 style={{
              fontSize: '15px', fontWeight: '700', margin: '0 0 18px',
              color: 'var(--text-dark)', display: 'flex', alignItems: 'center', gap: '8px',
            }}>
              <i className="ti ti-star" style={{ color: 'var(--warning-color)' }} aria-hidden="true"></i>
              What You Can Do in the Portal
            </h3>
            <div style={{ display: 'grid', gap: '10px' }}>
              {features.map(f => (
                <div key={f.title} style={{
                  display: 'flex', gap: '12px', alignItems: 'flex-start',
                  padding: '10px 12px', background: 'var(--bg-light)',
                  borderRadius: '8px', border: '1px solid var(--border-light)',
                }}>
                  <i className={`ti ${f.icon}`} style={{ color: 'var(--primary-color)', fontSize: '18px', marginTop: '2px' }} aria-hidden="true"></i>
                  <div>
                    <p style={{ margin: '0 0 2px', fontSize: '13px', fontWeight: '600', color: 'var(--text-dark)' }}>{f.title}</p>
                    <p style={{ margin: 0, fontSize: '12px', color: 'var(--text-light)' }}>{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* How credentials are sent */}
          <div style={{
            background: '#f0fdf4', border: '1.5px solid #10b981',
            borderRadius: '12px', padding: '20px',
            animation: 'slideInUp 0.7s ease-out',
          }}>
            <h3 style={{
              fontSize: '14px', fontWeight: '700', margin: '0 0 12px',
              color: '#065f46', display: 'flex', alignItems: 'center', gap: '8px',
            }}>
               How You Get Your Login
            </h3>
            <ol style={{ margin: 0, paddingLeft: '18px', color: '#047857', fontSize: '13px', lineHeight: 2.1 }}>
              <li>Submit your application (no account needed)</li>
              <li>Our team reviews and verifies your details</li>
              <li>On approval, a unique <strong>Beneficiary ID</strong> and password are generated</li>
              <li>Login credentials are emailed to your registered address</li>
              <li>Use those credentials here to access your portal</li>
            </ol>
          </div>
        </div>

      </div>

      {/* Support note */}
      <div style={{
        maxWidth: '1000px', margin: '28px auto 0',
        background: '#fee2e2', border: '1px solid #fecaca',
        borderRadius: '10px', padding: '16px 20px',
        display: 'flex', gap: '12px', alignItems: 'flex-start',
      }}>
        <span style={{ fontSize: '18px' }}></span>
        <p style={{ margin: 0, fontSize: '13px', color: '#7f1d1d', lineHeight: 1.7 }}>
          <strong>Never share your credentials.</strong> Our staff will never ask for your password. If you receive suspicious messages claiming to offer benefits, report immediately to <strong>1533</strong> or <strong>fraud@socialprotection.go.ke</strong>.
        </p>
      </div>
    </div>
  );
}

